export const formatToCurrencyString = (number: number) => {
  if (number) {
    return new Intl.NumberFormat().format(number);
  }
  return "0";
};
